jQuery(".slider--full").slick({
  slidesToShow: 1,
  infinite: true,
  arrows: true,
  dots: true,
});

jQuery(".menu-slider__inner").slick({
  slidesToShow: 6,
  arrows: true,
  responsive: [
    {
      breakpoint: 991,
      settings: "unslick",
    },
  ],
});

jQuery(".related.products .products, .up-sells .products").slick({
  slidesToShow: 3,
  arrows: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

jQuery(".image-gallery").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: "unslick",
    },
  ],
});

// Slick slides equal height
jQuery(".slider, #instagram .images, .image-gallery").on(
  "setPosition",
  function () {
    jQuery(this).find(".slick-slide").height("auto");
    var slickTrack = jQuery(this).find(".slick-track");
    var slickTrackHeight = jQuery(slickTrack).height();
    jQuery(this)
      .find(".slick-slide")
      .css("height", slickTrackHeight + "px");
  }
);
